import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import update from 'immutability-helper';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import { Message } from '../Message';
import { GroupingsService } from '../../services';
import GroupingForm from './grouping_form';

@connect(state => {
  return {
    me: state.user.me
  }
})
class GroupingEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      grouping: null,
      deviceGroupingId: props.match.params.deviceGroupingId,
      saved: false,
      localErrorMessage: null,
      localSuccessMessage: null
    };
  }

  componentDidMount() {
    GroupingsService.get(this.state.deviceGroupingId).then((response) => {
      this.setState({ grouping: response.grouping });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-group-edit') });
      console.log(error);
    });
    GroupingsService.getAllMetadataTypes().then((response) => {
      this.setState({types: response.types});
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-group-metadata-types') });
      console.log(error);
    })
  }

  messageDismissCallback() {
    this.setState({
      localErrorMessage: null,
      localSuccessMessage: null
    });
  }

  handleSubmit(data) {
    let localGrouping = "";
    let timezone = data.timezone;
    let name = data.name;
    let actionsEnabled = data.actionsEnabled;
    let metadata = [];
    this.state.types.forEach(function(element) {
      if(data[element.name]) {
        let metadataObject = {stringValue: data[element.name], deviceGroupingMetadataType: element}
        metadata[metadata.length] = metadataObject;
      }
    });
    if (!timezone) {
      localGrouping = update(this.state.grouping, {
        name: { $set: name }
      });
    } else {
      localGrouping = update(this.state.grouping, {
        name: { $set: name },
        timezone: { $set: timezone.value || false }
      });
    }
    localGrouping.metadata = metadata;
    localGrouping.actionsEnabled = actionsEnabled === true;

    GroupingsService.save(localGrouping).then(response => {
      this.setState({ saved: true });
    }).catch(error => {
      console.error(error); // TODO
    })
  }

  getType(token) {
    for (let i = 0; i < this.state.types.length; i++) {
      let curType = this.state.types[i]
      if (curType.token == token)
        return curType
    }
    return null
  }

  updateMapData(bounds, lat, long) {
    let localGrouping = this.state.grouping
    if (bounds != null) {
      let setBounds = false
      for (let i = 0; i < localGrouping.metadata.length; i++) {
        let e = localGrouping.metadata[i]
        if (e.deviceGroupingMetadataType.token == "geo_bounds") {
          localGrouping.metadata[i].stringValue = bounds
          setBounds = true
          break
        }
      }

      if (!setBounds) {
          let metadataObject = {stringValue: bounds, deviceGroupingMetadataType: this.getType("geo_bounds")}
          localGrouping.metadata[localGrouping.metadata.length] = metadataObject
      }

    }
    if (lat != null && long != null) {
      let setLat = false
      let setLong = false
      if (localGrouping.metadata) {
        for (let i = 0; i < localGrouping.metadata.length; i++) {
          let e = localGrouping.metadata[i]
          if (e.deviceGroupingMetadataType.token == "geo_lat") {
            setLat = true
            localGrouping.metadata[i].stringValue = lat
          } else if (e.deviceGroupingMetadataType.token == "geo_lon") {
            setLong = true
            localGrouping.metadata[i].stringValue = long
          }
        }
      } else {
        localGrouping.metadata = []
      }
      if(!setLat) {
        let metadataObject = {stringValue: lat, deviceGroupingMetadataType: this.getType("geo_lat")}
        localGrouping.metadata[localGrouping.metadata.length] = metadataObject
      }
      if(!setLong) {
        let metadataObject = {stringValue: long, deviceGroupingMetadataType: this.getType("geo_lon")}
        localGrouping.metadata[localGrouping.metadata.length] = metadataObject
      }
    }

    this.setState({ grouping: null });
    GroupingsService.save(localGrouping).then(response => {
      GroupingsService.get(this.state.deviceGroupingId).then((response) => {
        this.setState({ grouping: response.grouping });
      }).catch((error) => {
        this.setState({ errorMessage: i18next.t('messages.could-not-reload-group') });
        console.log(error);
      });
    }).catch(error => {
      console.error(error); // TODO
    })
  }

  render() {
    if (this.state.saved) {
      return (
          <Redirect to={{
            pathname: '/admin/groupings',
            state: {
              from: this.props.location,
              successMessage: i18next.t('pages.groups.groups-updated')
            }
          }}/>
      );
    } else if (!this.state.grouping || ! this.state.types) {
      return (
          <div className="loader">{i18next.t('loading')}</div>
      );
    } else {

      const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
      return (
          <div>
            <div className="row">
              <PageTitle title={this.state.grouping.name}
                         subTitle={`Parent Group: ${this.state.grouping.parent == null ? 'None' : this.state.grouping.parent.name}`}
                         backLinkWithParams={{
                           link: {
                             pathname: "/admin/groupings",
                             search: backLinkSearch
                           }
                         }} />
            </div>

            <Message
                messages={{ state: { successMessage: this.state.localSuccessMessage } }}
                errorMessage={this.state.localErrorMessage}
                messageDismissCallback={this.messageDismissCallback.bind(this)}
            />

            <GroupingForm
                types = {this.state.types}
                onSubmit={this.handleSubmit.bind(this)}
                groupingId={this.state.grouping.id}
                selectedGroupName={this.state.grouping.deviceGroup.name}
                groupName={this.state.grouping.name}
                actionsEnabled={this.state.grouping.actionsEnabled}
                groupTimezone={this.state.grouping.timezone}
                groupTimeReq={this.state.grouping.deviceGroup.requiresTimezone}
                metadata = {this.state.grouping.metadata}
                groupingBounds={this.state.grouping.metadata}
                updateMapData = {this.updateMapData.bind(this)}
                backLinkWithParams={{
                  link: {
                    pathname: "/admin/groupings",
                    search: backLinkSearch
                  }
                }}
            />
          </div>
      );
    }
  }
}

export default GroupingEdit;
